import { render, staticRenderFns } from "./ModalRecFacialV2.vue?vue&type=template&id=3e090ea7&scoped=true"
import script from "./ModalRecFacialV2.vue?vue&type=script&lang=js"
export * from "./ModalRecFacialV2.vue?vue&type=script&lang=js"
import style0 from "./ModalRecFacialV2.vue?vue&type=style&index=0&id=3e090ea7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e090ea7",
  null
  
)

export default component.exports